<template>
  <div>设备信息台账</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped></style>
